var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "46 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0139803 0H39.7917V6.43732H6.44496V14.3777H39.6437V46H0V39.5627H33.2128V32.2929H0.0139803V0ZM33.2128 25.8555V20.815H6.44496V25.8555H33.2128ZM48.204 0H54.635V21.7772H83.8424V0H90.2734V28.2145H72.4542V46H66.0232V28.2145H48.204V0ZM99.0877 0H141.157V46H134.726V6.43732H123.642V27.0904H117.211V6.43732H105.519V46H99.0877V0ZM149.703 0H190.433V46H149.703V0ZM156.134 6.43732V19.9935L184.002 19.9935V6.43732H156.134ZM184.002 26.4308L156.134 26.4308V39.5627H184.002V26.4308ZM200.678 46V0H207.109V46H200.678ZM217.355 0H258.085V46H217.355V0ZM223.786 6.43732V39.5627H251.654V6.43732H223.786ZM279.423 6.43732H264.516V0H300.154V6.43732H285.854V46H279.423V6.43732ZM308.224 46V0H314.655V46H308.224ZM322.486 0H360V6.43732H328.917V39.5627H360V46H322.486V0Z",
    fill: "#B6FF3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvsLogo);
export default __webpack_public_path__ + "static/media/avs-logo.11a597ff7ac16f67f5a3c54fd50ae747.svg";
export { ForwardRef as ReactComponent };